/**
 *  Panel state module file
**/

export const initialViewState = () => ({
  longitude: -5.967347942770048,
  latitude: 37.57669893463482,
  zoom: 4.5,
  pitch: 0,
  bearing: 0
})

export const state = {
  viewState: initialViewState()
}
